import axios from 'axios'

const BASE_URL = `${process.env.REACT_APP_BASE_API_URL}/users-api/users`

export interface CompleteRegistrationProps {
  email: string
  password: string
  inviteReference: string
  confirmPassword: string
}

async function login(email: any, password: any) {
  const response = await axios({
    method: 'post',
    url: BASE_URL.concat('/login'),
    data: {
      data: {
        email: email,
        password: password,
        rememberMe: false,
      },
    },
  })
  return response
}

function getUserToken() {
  return localStorage.getItem('user')
}

async function logout() {
  const response = await axios({
    method: 'post',
    url: BASE_URL.concat('/logOff'),
    headers: {
      Authorization: `Bearer ${getUserToken()}`,
    },
  })
  return response
}

async function resetPassword(email: any, password: any, token: any) {
  const response = await axios({
    method: 'post',
    url: BASE_URL.concat('/resetPassword'),
    data: {
      data: {
        email: email,
        password: password,
        confirmPassword: password,
        token: token,
      },
    },
  })
  return response
}

async function forgotPassword(email: any) {
  const response = await axios({
    method: 'post',
    url: BASE_URL.concat('/forgotPassword'),
    data: {
      data: {
        email: email,
      },
    },
  })
  return response
}

const completeRegistration = async ({
  email,
  password,
  confirmPassword,
  inviteReference,
}: CompleteRegistrationProps) => {
  const response = await axios({
    method: 'POST',
    url: `${BASE_URL}/completeRegistration`,
    data: {
      data: {
        email,
        password,
        confirmPassword,
        inviteReference,
      },
    },
  })

  return response
}

export const authAPI = {
  login,
  logout,
  resetPassword,
  forgotPassword,
  completeRegistration,
}
